var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.0625 12.9102C4.49414 12.9102 4.875 13.291 4.875 13.7227C4.875 14.1797 4.49414 14.5352 4.0625 14.5352H2.4375C1.06641 14.5352 0 13.4688 0 12.0977V5.59766C0 4.25195 1.06641 3.16016 2.4375 3.16016H4.0625C4.49414 3.16016 4.875 3.54102 4.875 3.97266C4.875 4.42969 4.49414 4.78516 4.0625 4.78516H2.4375C1.98047 4.78516 1.625 5.16602 1.625 5.59766V12.0977C1.625 12.5547 1.98047 12.9102 2.4375 12.9102H4.0625ZM12.7461 8.28906C13.0762 8.59375 13.0762 9.12695 12.7461 9.43164L9.49609 12.6816C9.19141 13.0117 8.6582 13.0117 8.35352 12.6816C8.02344 12.377 8.02344 11.8438 8.35352 11.5391L10.207 9.66016H4.875C4.41797 9.66016 4.0625 9.30469 4.0625 8.84766C4.0625 8.41602 4.41797 8.03516 4.875 8.03516H10.207L8.35352 6.18164C8.02344 5.87695 8.02344 5.34375 8.35352 5.03906C8.6582 4.70898 9.19141 4.70898 9.49609 5.03906L12.7461 8.28906Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon_logout.08a3f860a31eae3a5efac715acfb3144.svg";
export { ForwardRef as ReactComponent };